import React, { useState, useEffect, useContext } from 'react';
import { LanguageContext } from '../LanguageContext'; // For i18n
import axios from 'axios'; // If using the backend at all
import '../App.css';
import '../components/Home.css';
import './TestimonyPage.css';
import ArrowNavigation from "./ArrowNavigation";
import ContentDisplay from "./NeedsContentDisplay";
import PageDots from "./PageDots";
import { usePages } from './needspage';
import NavBar from '../components/NavBar'; // For top
import BottomBar from '../components/BottomBar'; // For bottom
import SubscriptionForm from '../components/SubscriptionForm';

// This relies on the frontend .env file
// Note that const cannot be above import statements
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function Needs() {
    const { language } = useContext(LanguageContext);
    const [text, setText] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const pages = usePages();
    // const variables
    // useEffect 

    useEffect(() => {
        // Load needs text in the selected language
        const textUrl = `${BASE_URL}/text/needs-${language}.txt`;
        fetch(textUrl)
            .then((res) => res.text())
            .then((data) => setText(data))
            .catch((err) => console.error('Error loading needs text:', err));
    }, [language]); // re-fetch when language changes

    // Helper function to convert email addresses to clickable links
    const convertEmailsToLinks = (text) => {
        const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

        return text.split(emailRegex).map((part, index) => {
            if (emailRegex.test(part)) {
                return (
                    <a
                        key={index}
                        href={`mailto:${part}`}
                        className="hyperlink"
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };

    const goToNextPage = () => {
        setCurrentPage((prevPage) => (prevPage + 1) % pages.length); // Loop around to the first page
    };

    const goToPreviousPage = () => {
        setCurrentPage((prevPage) => (prevPage - 1 + pages.length) % pages.length); // Loop around to the last page
    };

    // Don't render content until pages are loaded
    if (pages.length === 0) {
        return <div className="container">Loading...</div>;
    }

    return (
        <div>
            <NavBar />
            {/* <div className="text-section">
                {text && text.split('\n\n').map((para, idx) => (
                    <p key={idx}>
                        {convertEmailsToLinks(para)}
                    </p>
                ))}
            </div> */}

            <div className="container">
                <ArrowNavigation
                    goToPreviousPage={goToPreviousPage}
                    goToNextPage={goToNextPage}
                    currentPage={currentPage}
                    pages={pages}
                />
                <ContentDisplay content={pages[currentPage]} />
                <PageDots currentPage={currentPage} totalPages={pages.length} />
                <br />
            </div>
            <SubscriptionForm />
            {/* <BottomBar /> */}
        </div>
    );
};

export default Needs;